import React from "react";
import { AiAdvisor } from "@/components/AiAdvisor";
import { useI18n } from "@/context/I18nContext";
import { ADVISOR_IMAGE } from "@/data/moduleMedia";

export function AdvisorSection() {
  const { lang } = useI18n();
  const L = (fr, en) => (lang === "en" ? en : fr);
  return (
    <section id="conseiller" className="relative py-24 lg:py-32 border-t border-white/10" data-testid="advisor-section">
      <div className="mx-auto max-w-7xl px-5 lg:px-8 grid gap-12 lg:grid-cols-2 lg:items-center">
        <div>
          <span className="text-xs font-mono uppercase tracking-[0.3em] text-[#EAB308]">{L("Conseiller intelligent", "Smart advisor")}</span>
          <h2 className="mt-3 text-4xl sm:text-5xl font-extrabold text-white tracking-tight">
            {L("Quels modules pour", "Which modules for")} <span className="text-[#EAB308]">{L("votre entreprise ?", "your business?")}</span>
          </h2>
          <p className="mt-4 text-white/60 text-lg">
            {L("Notre IA analyse votre réalité de chantier et vous propose la combinaison PROGÈRE la plus rentable — avec le bon palier et les rabais multi-modules.", "Our AI analyzes your job-site reality and suggests the most cost-effective PROGÈRE combination — with the right tier and multi-module discounts.")}
          </p>
          <div className="mt-8 overflow-hidden rounded-2xl border border-white/10">
            <img src={ADVISOR_IMAGE} alt="PROGÈRE AI" className="w-full object-cover" />
          </div>
        </div>
        <AiAdvisor />
      </div>
    </section>
  );
}
